export const Label = {
  ALL_STREETS: 'Filter Streets',
  ALL_CITIES: 'Filter Cities',
  ALL_ROUTES: 'Filter Routes',
  ALL_TYPES: 'Filter Types',
  ALL_DIVISIONS: 'Filter Divisions',
  ALL_WELLS: 'Filter Wells'
}

export const FilterType = {
  STREET: 'street',
  CITY: 'city',
  ROUTE: 'route',
  PROPERTY_TYPE: 'property_type',
  DIVISION: 'division_type',
  WELL: 'well'
}

export const Role = {
  ADMIN: 'admin',
  USER: 'user',
  RESIDENT: 'resident'
}

export const ServiceState = {
  IDLE: "Process Idle",
  RETRIEVING_UBMAX: 'Retrieving UBMax Updates',
  PROCESSING_DELETES: 'Processing Deleted',
  PROCESSING_UPDATES: 'Processing Updates',
  UPDATE_COMPLETE: 'Update Complete',
  ERROR: 'Sync Error'
}

let API_BASE_URL = 'https://us-central1-public-alert-prod.cloudfunctions.net';
if (location.hostname === "localhost") {
  API_BASE_URL = 'http://localhost:5001/public-alert-prod/us-central1';
}

export { API_BASE_URL };
